import React from "react";
import { AdminLoginDiv } from "./style";
import llogo from "../../../../assets/images/llogo.png";
import { Link } from "react-router-dom";

function AdminLogin() {
  return (
    <AdminLoginDiv>
      <div className="row inner-container">
        <div className="col-md-6 right-div">
          <h3 className="">Admin Login</h3>
          <form>
            <div className="form-group">
              <input
                type="email"
                className="form-control"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
                placeholder=" Enter Admin Email"
              />

            </div>

            <div className="form-group">
              <input
                type="password"
                className="form-control"
                id="exampleInputPassword1"
                placeholder="Enter Admin Passcode"
              />
            </div>

            <button type="submit" className="btn">
              Login
            </button>
          </form>
      
          <img className="pt-5" src={llogo} />
        </div>
      </div>
    </AdminLoginDiv>
  );
}

export default AdminLogin;
